export default "__VITE_ASSET__9aeab025__"